// removed by extract-text-webpack-plugin
module.exports = {"box":"Box__box___-6e8v","box-dark":"Box__box-dark___2Qkru Box__box___-6e8v","mediumDark":"Box__mediumDark___3B6QA","noMargin":"Box__noMargin___1zZXJ","header":"Box__header___3wWk-","center":"Box__center___2lXgS","title":"Box__title___3x077 _typography__h6___1u75q _typography__headers___eO5yD _typography__text-ellipsis___tUHkx","info":"Box__info___1CUgQ _typography__smallInfo___e4AsH _typography__headers___eO5yD","body":"Box__body___2Qa1y","padding":"Box__padding___12m-k","footer":"Box__footer___3sh3J"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/Box.scss
// module id = 542
// module chunks = 0